// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, Button, IconButton, TextField, Tooltip } from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";
import { Delete, Edit } from "@mui/icons-material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import BackButton from "components/shared/BackButton";
import PaginationCM from "components/shared/Pagination";

// helper
import Toast from "helper/toast";
import GenerateHeadCell from "helper/generate-head-cell";

// styled component
import { StyledStack, StyledTitle, ButtonContainer } from "./addCategory.style";

// constants
import { PAGINATION_LIMIT } from "constants";

// request methods
import { addProductsCategoryRequest } from "api/requests/products";

// validation
import { categorySchema, validateImg } from "validations";
import Upload from "components/shared/Upload";

export default function AddProductsCategory() {
  const params = useParams();

  const navigate = useNavigate();

  const {
    request,
    loading,
    setLoading,
    isUploading,
    uploadProgress,
    setUploadProgress,
  } = useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(categorySchema),
  });

  // upload category image state
  const [productCategoryImage, setProductCategoryImage] = useState({
    url: null,
    isChanged: false,
  });

  // uploaded image handler method
  const handleChangeProductCategoryImage = (val) => {
    validateImg(val);
    setProductCategoryImage({ url: val, isChanged: true });
  };

  // add category
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        addProductsCategoryRequest(
          { ...data, image: productCategoryImage },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      reset({
        title: "",
      });
      Toast({ type: "success", title: "ثبت سردسته " });
      navigate("/products/category");
    }
    setLoading(false);
  };

  return (
    <DrawerCM title="افزودن سردسته محصولات">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/products/category" />
            </Grid>
            <StyledStack>
              <Grid>
                <Grid justifyContent="space-between">
                  <StyledTitle>افزودن سردسته محصولات</StyledTitle>
                </Grid>

                <Grid container>
                  <Grid item md={10} sm={9} xs={12} p={1.5}>
                    <TextField
                      label="عنوان سردسته"
                      variant="outlined"
                      fullWidth
                      id="title"
                      {...register("title")}
                      error={Boolean(errors.title)}
                      helperText={errors.title?.message}
                    />
                  </Grid>
                  <ButtonContainer item md={2} sm={3} xs={12}>
                    <Button
                      color="success"
                      startIcon={<CheckIcon />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      ثبت
                    </Button>
                  </ButtonContainer>
                  <Grid item md={6} xs={12} p={1.2}>
                    {productCategoryImage.url ? (
                      <Upload
                        isWeb={productCategoryImage.isWeb}
                        isLocal={!productCategoryImage.isWeb}
                        file={productCategoryImage.url}
                        refillable
                        type="add-image"
                        onChange={handleChangeProductCategoryImage}
                        width={"100%"}
                        height={"100%"}
                        objectFit="contain"
                      />
                    ) : (
                      <Upload
                        isLocal={productCategoryImage.isChanged}
                        file={productCategoryImage.url}
                        refillable
                        type="add-image"
                        onChange={handleChangeProductCategoryImage}
                        width={"100%"}
                        height={"100%"}
                        objectFit="contain"
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
